import { Routes, Route, Navigate } from "react-router-dom";
import { Dashboard } from "./pages/Dashboard";
import { Transactions } from "./pages/Transactions";
import { Invoices } from "./pages/Invoices";
import { MatchReview } from "./pages/MatchReview";
import { InvoiceGaps } from "./pages/InvoiceGaps";
// Exceptions page deprecated in v3.0.42 — covered by Stage NEEDS_INVOICE
// on /transactions + the /matches review surface.
import { AgentStatus } from "./pages/AgentStatus";
import { RulesEngine } from "./pages/RulesEngine";
import { AuditTrail } from "./pages/AuditTrail";
import { Settings } from "./pages/Settings";
import { PendingReview } from "./pages/PendingReview";
import { PipelineErrors } from "./pages/PipelineErrors";
import { Duplicates } from "./pages/Duplicates";
import { QBQueue } from "./pages/QBQueue";
import { ReviewQueue } from "./pages/ReviewQueue";
import { VendorsAdminPage }    from "./pages/admin/VendorsAdminPage";
import { GlAccountsAdminPage } from "./pages/admin/GlAccountsAdminPage";
import { CardsAdminPage }      from "./pages/admin/CardsAdminPage";
import { PostingRulesAdminPage } from "./pages/admin/PostingRulesAdminPage";
import { TransactionsTrash }   from "./pages/TransactionsTrash";

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/transactions" element={<Transactions />} />
      <Route path="/invoices" element={<Invoices />} />
      <Route path="/matches" element={<MatchReview />} />
      <Route path="/gaps" element={<InvoiceGaps />} />
      {/* /exceptions redirects to /matches — the canonical review surface */}
      <Route path="/exceptions" element={<Navigate to="/matches" replace />} />
      <Route path="/agents" element={<AgentStatus />} />
      <Route path="/rules" element={<RulesEngine />} />
      <Route path="/audit" element={<AuditTrail />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/pending-review" element={<PendingReview />} />
      <Route path="/pipeline-errors" element={<PipelineErrors />} />
      <Route path="/duplicates" element={<Duplicates />} />
      <Route path="/qb-queue" element={<QBQueue />} />
      <Route path="/review-queue" element={<ReviewQueue />} />
      {/* Admin redirect — D-04 */}
      <Route path="/admin" element={<Navigate to="/admin/vendors" replace />} />
      {/* Phase 10 admin CRUD pages */}
      <Route path="/admin/vendors"     element={<VendorsAdminPage />} />
      <Route path="/admin/gl-accounts" element={<GlAccountsAdminPage />} />
      <Route path="/admin/cards"       element={<CardsAdminPage />} />
      <Route path="/admin/posting-rules" element={<PostingRulesAdminPage />} />
      {/* Phase 1 — Soft-delete Trash screen */}
      <Route path="/transactions/trash" element={<TransactionsTrash />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
